// utils/tabletMode.js
// The installed Android tablet app (TWA) launches its start_url as "/?tablet=1".
// We persist that flag so the whole installed app stays in photographer-only mode
// across in-app navigation, while the same site opened in a normal browser (used by
// reviewers/supervisors on desktop) keeps the full feature set.

let _cached = null;

export function isTabletMode() {
  if (_cached !== null) return _cached;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tablet') === '1') {
      localStorage.setItem('tablet_mode', '1');
    }
    _cached = localStorage.getItem('tablet_mode') === '1';
  } catch {
    _cached = false;
  }
  return _cached;
}

// Installed APK version, so the update banner knows when /download has a newer
// build. APK v2+ launches with "&apkv=<versionCode>" in the start URL; the
// original TWA (versionCode 1) predates the param, so an installed tablet app
// without it counts as version 1.
export function getInstalledApkVersion() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = parseInt(params.get('apkv'), 10);
    if (!Number.isNaN(fromUrl)) {
      localStorage.setItem('apk_version_code', String(fromUrl));
      return fromUrl;
    }
    const stored = parseInt(localStorage.getItem('apk_version_code'), 10);
    if (!Number.isNaN(stored)) return stored;
    return isTabletMode() ? 1 : 0;
  } catch {
    return 0;
  }
}
